import { render, staticRenderFns } from "./TariffSelect.vue?vue&type=template&id=66ef3cf4"
import script from "./TariffSelect.vue?vue&type=script&lang=js"
export * from "./TariffSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports